import BASIC from "./basic";

export default {
  ...BASIC,
  background: '#9ed0ff',
  color: '#338288',
};